<template>
    <div>
        <div v-if="loaded">
            <!-- Row top buttons -->
            <div class="row q-mb-lg">
                <div class="col-6" style="justify-content: flex-start">
                    <q-btn
                        class="capitalize ctrl-button"
                        color="grey-5"
                        :label="`${$store.state.stringsStore.strings.action.toOverview}`"
                        @click="$router.push('/location')"
                        icon="keyboard_backspace"
                    />
                </div>
                <div class="col-6">
                    <q-btn
                        ref="save"
                        class="capitalize ctrl-button right q-mr-sm"
                        :color="readOnly ? 'grey-5' : 'ctrl-turquoise'"
                        :label="
                            readOnly
                                ? getString('action.edit')
                                : getString('action.save')
                        "
                        @click="saveChanges"
                        :icon-right="readOnly ? 'edit' : 'save'"
                    />
                    <q-btn
                        v-if="$route.params.id"
                        class="q-mr-md capitalize ctrl-button right"
                        icon-right="delete"
                        color="negative capitalize"
                        :label="$store.state.stringsStore.strings.action.delete"
                        align="right"
                        @click="removeLocation"
                    />
                </div>
            </div>

            <!-- Columns -->
            <div class="row gutter-sm q-mb-lg">
                <!-- Left -->
                <div class="col-md-6 col-sm-12 col-xs-12 q-pa-sm">
                    <div class="row q-mb-sm">
                        <div class="full-width">
                            <p class="card-title">
                                {{ getString("action.details") }}
                            </p>

                            <div class="card-block">
                                <div class="row">
                                    <q-field
                                        class="full-width"
                                        :error="
                                            $v.data.name.$dirty &&
                                            !$v.data.name.required
                                        "
                                        :errorLabel="
                                            $store.state.stringsStore
                                                .language === 'nl'
                                                ? 'Naam is verplicht'
                                                : 'Name is required'
                                        "
                                    >
                                        <q-input
                                            :disable="readOnly"
                                            type="text"
                                            class="full-width"
                                            :float-label="`${getString(
                                                'name'
                                            )} *`"
                                            v-model="data.name"
                                        />
                                    </q-field>

                                    <q-field
                                        class="full-width"
                                        :error="
                                            $v.data.phone.$dirty &&
                                            (!$v.data.phone.required ||
                                                !$v.data.phone.phoneNumber)
                                        "
                                        :errorLabel="
                                            $store.state.stringsStore
                                                .language === 'nl'
                                                ? 'Telefoonnummer is verplicht en moet numeriek zijn'
                                                : 'Phone number is required and must be numeric'
                                        "
                                    >
                                        <q-input
                                            type="tel"
                                            :disable="readOnly"
                                            maxLength="15"
                                            class="full-width q-mb-md"
                                            :float-label="`${getString(
                                                'module.location.details.phone'
                                            )} *`"
                                            v-model="data.phone"
                                        />
                                    </q-field>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-md-6"></div>
                                    <div class="col-xs-12 col-md-6"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Right -->
                <div class="col-md-6 col-sm-12 col-xs-12 q-pa-sm">
                    <div class="full-width">
                        <p class="card-title">
                            {{
                                $store.state.stringsStore.language === "nl"
                                    ? "Adres"
                                    : "Address"
                            }}
                        </p>

                        <div class="card-block">
                            <div class="row">
                                <div class="col-md-9">
                                    <q-input
                                        :error="
                                            $v.data.address.street.$dirty &&
                                            !$v.data.address.street.required
                                        "
                                        type="text"
                                        :disable="readOnly"
                                        class="full-width q-mb-md"
                                        :float-label="
                                            `${getString(
                                                'module.location.details.street.name'
                                            )} *`
                                        "
                                        v-model="data.address.street"
                                    />
                                </div>
                                <div class="col-md-3 q-pl-md">
                                    <q-input
                                        type="text"
                                        :disable="readOnly"
                                        maxLength="6"
                                        class="full-width q-mb-md"
                                        :error="
                                            $v.data.address.streetnumber.$dirty &&
                                            !$v.data.address.streetnumber.required
                                        "
                                        :float-label="
                                            `${getString(
                                                'module.location.details.street.number'
                                            )} *`
                                        "
                                        v-model="data.address.streetnumber"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <q-input
                                        type="text"
                                        :disable="readOnly"
                                        class="full-width q-mb-md"
                                        :error="
                                            $v.data.address.zipcode.$dirty &&
                                            !$v.data.address.zipcode.required
                                        "
                                        :float-label="
                                            `${getString(
                                                'module.location.details.zipcode'
                                            )} *`
                                        "
                                        v-model="data.address.zipcode"
                                    />
                                </div>
                                <div class="col-md-8 q-pl-md">
                                    <q-input
                                        type="text"
                                        :disable="readOnly"
                                        class="full-width q-mb-md"
                                        :error="
                                            $v.data.address.city.$dirty &&
                                            !$v.data.address.city.required
                                        "
                                        :float-label="
                                            `${getString(
                                                'module.location.details.city'
                                            )} *`
                                        "
                                        v-model="data.address.city"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <q-input
                                        type="text"
                                        :disable="readOnly"
                                        class="full-width q-mb-md"
                                        :error="
                                            $v.data.address.country.$dirty &&
                                            !$v.data.address.country.required
                                        "
                                        :float-label="
                                            `${getString(
                                                'module.location.details.country'
                                            )} *`
                                        "
                                        v-model="data.address.country"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="loader" v-else>
            <q-spinner color="grey-5" :size="80" />
        </div>
    </div>
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators';

// Mixins
import saveChanges from '@/mixins/detailViews/saveChanges';
import fetchDetail from '@/mixins/detailViews/fetchDetail';
import createUuid from '@/helpers/createUuid';
import getString from '@/helpers/GetStrings';
import college from '@/plugins/api/college/college';

const phoneNumber = helpers.regex('phone', /^[0-9\d\-+_\s]+$/i);

export default {
  mixins: [
    fetchDetail,
    saveChanges,
    college,
  ],
  components: {
  },
  validations: {
    data: {
      name: {
        required,
      },
      phone: {
        required,
        phoneNumber,
      },
      address: {
        street: {
          required,
        },
        streetnumber: {
          required,
        },
        zipcode: {
          required,
        },
        city: {
          required,
        },
        country: {
          required,
        },
      },
    },
  },
  data() {
    return {
      loaded: false,
      readOnly: true,
      guid: createUuid(),
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      permission: 'location',
      // Where data is fetched from
      endpoint: 'location',
      // The object key from the response object
      responseData: {
        single: 'location',
        multiple: 'locations',
      },
      // Used for navigation on the front-end (matching the router)
      module: 'location',
      imageModal: false,
      containsErrors: true,
      data: {
        name: '',
        phone: '',
        address: {
          street: '',
          streetnumber: '',
          city: '',
          country: '',
          zipcode: '',
        },
      },
      labelSet: false,
      plugins: [],
    };
  },

  methods: {
    getString,

    requestParams() {
      const params = {
        name: this.data.name,
        phone: this.data.phone,
        street: this.data.address.street,
        streetnumber: this.data.address.streetnumber,
        city: this.data.address.city,
        zipcode: this.data.address.zipcode,
        country: this.data.address.country,
      };

      for (const [key, value] of Object.entries(params)) {
        // If the value is not null, undefined or empty, remove it from the params.
        if (!value) delete params[key];
      }

      return params;
    },

    removeLocation() {
      // Dialog
      this.$q.dialog({
        title: '',
        message: this.getString('module.library.delete.title.single'),
        ok: this.$store.state.stringsStore.strings.dialog.confirm.ok,
        cancel: this.$store.state.stringsStore.strings.dialog.confirm.cancel,
      }).then(() => {
        // delete call
        this.deleteLocation(this.$route.params.id).then(() => {
          this.$q.notify({
            message: this.getString(null, 'Location successfully removed', 'Locatie succesvol verwijderd'),
            timeout: 2000,
            type: 'positive',
            position: 'top-right',
          });
          this.$router.push('/location');
        });
      }).catch(() => {
        console.warn('Not removed');
      });
    },
  },

  async mounted() {
    if (this.$route.params.id) {
      this.data = await this.getCourseLocation(this.$route.params.id);
    } else {
      this.readOnly = false;
    }
    this.loaded = true;
  },
};
</script>

<style lang="stylus" scoped>
.full-height
  height: 100%
</style>
